import { createSlice, createAsyncThunk, AsyncThunk } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "services/CRUDServices";
import { filterUrls } from "services/api.enums";

export const filterContradictionTrakingModel: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "contradictionTraking",
  async (body: any) => {
    // delete body.pageNumber
    const data = await filterTableDataAPI(
      filterUrls.contradictionTraking,
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,10,false
    );

    return data.data;
  }
);

const initialState: any = {
  contradictionTrakingData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
};

const ContradictionTrakingLists = createSlice({
  initialState: initialState,
  name: "contradictionTraking",
  reducers: {
    clearContradiction: (state) => {
      state.contradictionTrakingData = [];
    },
    setFilterContradiction: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterContradictionTrakingModel.fulfilled as any]: (state, action) => {

      state.contradictionTrakingData = action.payload;
      state.fetchPost = false;
    },
    [filterContradictionTrakingModel.pending as any]: (state) => {
      state.fetchPost = true;
    },
    [filterContradictionTrakingModel.rejected as any]: (state) => {
      state.fetchPost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { setFilterContradiction, clearContradiction } = ContradictionTrakingLists.actions;
export default ContradictionTrakingLists.reducer;
